import { z } from "zod";

import { ignoreDuplicateWorkPolicySchema } from "./enums";

export const ignoreDuplicateWorkConfigurationSchema = z.object({
	policy: ignoreDuplicateWorkPolicySchema,
	source: z.string().optional(),
});
